import { render, staticRenderFns } from "./ThePreviewIngredients.vue?vue&type=template&id=1039b536&scoped=true&"
import script from "./ThePreviewIngredients.vue?vue&type=script&lang=js&"
export * from "./ThePreviewIngredients.vue?vue&type=script&lang=js&"
import style0 from "./ThePreviewIngredients.vue?vue&type=style&index=0&id=1039b536&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1039b536",
  null
  
)

export default component.exports